import dynamic from 'next/dynamic';

export const TrustedDevicesEditable = dynamic(() => import('./TrustedDevices').then(mod => mod.TrustedDevicesEditable));
